import { generalSolanaTransactionExecutor } from '@rango-dev/signer-solana';
import base58 from 'bs58';
export class SolanaSigner {
    provider;
    constructor(provider) {
        this.provider = provider;
    }
    async signMessage(msg) {
        const encodedMessage = new TextEncoder().encode(msg);
        const signedMessage = await this.provider.signMessage({
            message: encodedMessage,
        });
        return base58.encode(signedMessage.signature);
    }
    async signAndSendTx(tx) {
        const DefaultSolanaSigner = async (solanaWeb3Transaction) => {
            const signature = await this.provider.signTransaction({
                transaction: solanaWeb3Transaction.serialize(),
            });
            return signature.signedTransaction;
        };
        const hash = await generalSolanaTransactionExecutor(tx, DefaultSolanaSigner);
        return { hash };
    }
}
